/**
 * PKCE 協議相關代碼
 */
import CryptoJS from 'crypto-js';

const defaultLocalStorageKey = 'code_verifier';

/**
 * 生成隨機串
 */
function generateRandomString(length = 32) {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

/**
 * 生成 code_verifier
 */
export function generateCodeVerifier() {
  return generateRandomString(32);
}

/**
 * 存儲 code_verifier
 */
export function saveCodeVerifier(code_verifier: string, key = defaultLocalStorageKey) {
  sessionStorage.setItem(key, code_verifier);
}

/**
 * 獲取 code_verifier
 */
export function getCodeVerifier(key = defaultLocalStorageKey) {
  if (!GOV_MO.PKCE) {
    return null;
  }
  return sessionStorage.getItem(key);
}

function base64URL(str: CryptoJS.lib.WordArray) {
  return str
    .toString(CryptoJS.enc.Base64)
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

/**
 * 生成 code_challenge
 */
export function generateCodeChallenge(code_verifier: string | null) {
  // 利用 queryString.stringifyUrl 傳遞 void 0 時不生成參數的規則
  if (!code_verifier) {
    return;
  }
  return base64URL(CryptoJS.SHA256(code_verifier));
}
